module.exports = __webpack_public_path__ + "static/media/1.e328cc38.jpg";